import DemoTransactionsTableItemDetails from './DemoTransactionsTableItemDetails'

export default DemoTransactionsTableItemDetails
